// @ts-check
import React from 'react';
import cx from 'classnames';
import { Field } from 'utils/reduxFormWrapper';
import { showModal } from 'shared/actions/ModalActions';
import styles from './InboundOrOutboundToggle.module.scss';
import OutboundIconSrc from './images/outbound_icon.svg';
import OutboundIconFocusedSrc from './images/outbound_icon-focused.svg';
import InboundIconSrc from './images/inbound_icon.svg';
import InboundIconFocusedSrc from './images/inbound_icon-focused.svg';

const InfoLink = () => (
  <span
    className={cx('fake-link', styles.help_link)}
    onClick={() => showModal({ name: 'inboundVsOutboundInfo' })}
  >
    Not sure which to choose?
  </span>
);

const OutboundInfo = () => (
  <div className={styles.info_section}>
    <h3 className={styles.title}>Outbound Referral</h3>
    <p className={styles.explanation}>You are referring a patient to another provider.</p>
    <InfoLink />
  </div>
);

const InboundInfo = () => (
  <div className={styles.info_section}>
    <h3 className={styles.title}>Inbound Referral</h3>
    <p className={styles.explanation}>
      You are entering a referral you received from another provider.
    </p>
    <InfoLink />
  </div>
);

const ToggleInput = ({ input: { value, onChange } }) => (
  <div className={styles.ToggleInput}>
    <div className={styles.control_section}>
      <Toggle
        onToggle={val => (val === 'outbound' ? onChange(true) : onChange(false))}
        value={value ? 'outbound' : 'inbound'}
      />
    </div>
    {value ? <OutboundInfo /> : <InboundInfo />}
  </div>
);

const Toggle = ({ onToggle, value }) => (
  <div className={styles.Toggle_container}>
    <div
      className={cx(styles.Toggle_side, styles.left, { [styles.is_active]: value === 'outbound' })}
      onClick={() => onToggle('outbound')}
    >
      <div className={styles.Toggle_icon_container}>
        <img src={value === 'outbound' ? OutboundIconFocusedSrc : OutboundIconSrc} alt="outbound" />
      </div>
      <div className={styles.Toggle_label}>Outbound</div>
    </div>
    <div
      className={cx(styles.Toggle_side, styles.right, { [styles.is_active]: value === 'inbound' })}
      onClick={() => onToggle('inbound')}
    >
      <div className={styles.Toggle_icon_container}>
        <img src={value === 'inbound' ? InboundIconFocusedSrc : InboundIconSrc} alt="inbound" />
      </div>
      <div className={styles.Toggle_label} data-spec-id="inbound-toggle">
        Inbound
      </div>
    </div>
  </div>
);

const InboundOrOutboundToggle = () => <Field name="enteredBySender" component={ToggleInput} />;

export default InboundOrOutboundToggle;
